import { faImage } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"

import { useSendMailModalStore } from "./hooks/useSendMailModalStore"

const MailPhotoUploadButton = () => {
  const { setImageFile, imagePreviewUrl, setImagePreviewUrl } =
    useSendMailModalStore()
  const { t } = useTranslation()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]
    if (file) {
      if (file.type === "image/png") {
        setImageFile(file)
        setImagePreviewUrl(URL.createObjectURL(file))
      } else {
        // image is jpg, convert to png
        const img = new window.Image()
        const reader = new FileReader()
        reader.onload = (event) => {
          img.onload = () => {
            const canvas = document.createElement("canvas")
            canvas.width = img.width
            canvas.height = img.height
            const ctx = canvas.getContext("2d")
            if (ctx) {
              ctx.drawImage(img, 0, 0)
              canvas.toBlob((blob) => {
                if (blob) {
                  const pngFile = new File([blob], "image.png", {
                    type: "image/png",
                  })
                  setImageFile(pngFile)
                  setImagePreviewUrl(URL.createObjectURL(pngFile))
                }
              }, "image/png")
            }
          }
          img.src = event.target?.result as string
        }
        reader.readAsDataURL(file)
      }
    }
  }

  return (
    <>
      <input
        onChange={handleFileChange}
        type="file"
        accept="image/png, image/jpg"
        id="file-upload"
        style={{ display: "none" }}
      />
      <Button
        text={
          <div className="flex flex-row gap-1 items-center">
            <FontAwesomeIcon icon={faImage} />
            <Typography variant="body">{t("MAIL_PHOTO")}</Typography>
          </div>
        }
        onClick={() => {
          document.getElementById("file-upload")?.click()
        }}
        buttonType="secondary"
        size="small"
        disabled={!!imagePreviewUrl}
        fullWidth
      />
    </>
  )
}

export default MailPhotoUploadButton
